module.exports = __webpack_public_path__ + "static/6M_2024_Investor_call_Dial-in_information-95d2018717152201ab2f943d35591220.pdf";